import { render, staticRenderFns } from "./OptionChain.vue?vue&type=template&id=64f03df0&scoped=true&"
import script from "./OptionChain.vue?vue&type=script&lang=ts&"
export * from "./OptionChain.vue?vue&type=script&lang=ts&"
import style0 from "./OptionChain.vue?vue&type=style&index=0&id=64f03df0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f03df0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VDataTable,VIcon,VSlideYTransition})
